import { ApplicationRef, Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MenuController } from '@ionic/angular';

/** Id del ion-menu usado como panel de agendamiento offline (side="end"). */
export const VISITA_OFFLINE_PANEL_MENU_ID = 'visita-panel-offline';

@Injectable({ providedIn: 'root' })
export class VisitaOfflinePanelService {
  private readonly menuController = inject(MenuController);
  private readonly appRef = inject(ApplicationRef);
  private readonly _abierto = new BehaviorSubject<boolean>(false);
  private readonly _guardado = new Subject<void>();

  /** Emisión cuando se guarda offline (para refrescar la lista). */
  readonly guardado$ = this._guardado.asObservable();

  get menuId(): string {
    return VISITA_OFFLINE_PANEL_MENU_ID;
  }

  getAbierto(): boolean {
    return this._abierto.value;
  }

  /**
   * Abre el panel overlay. No ligar `[disabled]` al flag: provoca carreras con
   * `MenuController.open()` (open falla hasta el próximo ciclo de detección de cambios).
   */
  abrir(): void {
    this._abierto.next(true);
    this.appRef.tick();

    const intentarAbrir = (): void => {
      void this.menuController.enable(true, VISITA_OFFLINE_PANEL_MENU_ID);
      void this.menuController.open(VISITA_OFFLINE_PANEL_MENU_ID).then(ok => {
        if (!ok) {
          requestAnimationFrame(() => {
            void this.menuController.open(VISITA_OFFLINE_PANEL_MENU_ID);
          });
        }
      });
    };

    requestAnimationFrame(() => {
      intentarAbrir();
    });
  }

  cerrar(): void {
    this.menuController.close(VISITA_OFFLINE_PANEL_MENU_ID);
  }

  alCerrarMenu(): void {
    this._abierto.next(false);
  }

  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.cerrar();
    }
  }

  onGuardado(): void {
    this._guardado.next();
  }
}
